import { h } from 'preact'
import styles from './MatchStatus.module.css'
import { IMatchData } from '../../lib/model'
import { useCustomContext } from '../../lib/context'

interface Props {
  matchData: IMatchData
  statusLabel: string
}

function filterTvChannel(tvchannel: String): String {
  if (tvchannel.includes('TV 2 Direkte')) {
    return 'TV 2'
  }
  return tvchannel
}

export function MatchStatus(props: Props) {
  const context = useCustomContext()
  const handleClick = () => {
    context?.sendGaEvent({ eventAction: 'click', eventLabel: props.matchData.resultLink })
  }
  return props.statusLabel === 'Plannlagt' ? (
    <div class={styles['dh-fotball-banner__match-status']}>
      <a href={props.matchData.resultLink} onClick={handleClick}>
        <time>{formatTime(props.matchData.timestamp)}</time>
        <div class={styles['dh-fotball-banner__match-status__tvchannel']}>
          {filterTvChannel(props.matchData.tvChannel)}
        </div>
      </a>
    </div>
  ) : (
    <div class={styles['dh-fotball-banner__match-status']}>
      <a href={props.matchData.resultLink} onClick={handleClick}>
        <div
          class={
            props.statusLabel === 'Pågår' ? styles['dh-fotball-banner__match-status-ongoing'] : ''
          }
        >
          {props.statusLabel === 'Pågår' && (
            <span class={styles['dh-fotball-banner__match-status__live-pulsar']}>
              <svg
                viewBox="0 0 24 24"
                width="1.500em"
                height="1.500em"
                fill="#FF7461"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
                  opacity=".5"
                ></path>
                <path d="M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"></path>
              </svg>
            </span>
          )}
          {props.statusLabel}
        </div>
        <div class={styles['dh-fotball-banner__match-status__tvchannel']}>
          {props.matchData.tvChannel}
        </div>
      </a>
    </div>
  )
}

function formatTime(matchDate) {
  if (!matchDate) {
    return matchDate
  }
  const date = new Date(matchDate)
  const minutes = `0${date.getMinutes()}`.slice(-2)
  return `${date.getHours()}:${minutes}`
}
